export function useCacheCleaner() {
    const clearPWAAppCache = async () => {
        try {
            console.log("🧹 شروع پاکسازی کش‌های PWA...");

            // 1️⃣ حذف سرویس ورکر (Service Worker)
            if ('serviceWorker' in navigator) {
                const registrations = await navigator.serviceWorker.getRegistrations();
                for (let registration of registrations) {
                    await registration.unregister();
                }
            }

            // 2️⃣ حذف Cache Storage
            if ('caches' in window) {
                const cacheNames = await caches.keys();
                await Promise.all(cacheNames.map(name => caches.delete(name)));
            }

            // 3️⃣ حذف LocalStorage و SessionStorage
            // localStorage.clear();
            sessionStorage.clear();

            // 4️⃣ حذف IndexedDB
            if ('indexedDB' in window) {
                const dbs = await indexedDB.databases();
                for (let db of dbs) {
                    indexedDB.deleteDatabase(db.name);
                }
            }

            console.log("✅ پاکسازی کش PWA کامل شد! رفرش صفحه...");

            // 5️⃣ Hard Refresh صفحه (معادل Ctrl + F5)
            window.location.reload(true);

        } catch (error) {
            console.error("❌ خطا در پاکسازی کش PWA:", error);
        }
    };

    return { clearPWAAppCache };
}
